import React, { useEffect, useState } from 'react';
import {
  SyncFailureMetaData, SyncFailureTypeEnum,
  SyncFailureTypes,
} from '../ActivationSyncHistory/models/sync-failure';
import { SyncHistoryItemFactory } from '../ActivationSyncHistory/factory';
import ActivationsAPI from '../api/ActivationsAPI';
import { SyncHistoryItem } from '../ActivationSyncHistory/models/sync-history-item';
import FailedRecordsCard from '../FailedRecordsCard/FailedRecordsCard';

function ActivationSummary({ activation }) {

  const [transientErrorsMetaData, setTransientErrorsMetaData] = useState<any>({
    recordsFailedCount: 0
  });
  const [permanentErrorsMetaData, setPermanentErrorsMetaData] = useState<any>({});

  const [lastRetriedSyncRun, setLastRetriedSyncRun] = useState<SyncHistoryItem>();
  const syncFailureTypes = SyncFailureTypeEnum;

  useEffect(() => {
    fetchActivationErrorsMeta();
    getLastRetriedSyncItem();
  }, [activation]);

  const fetchActivationErrorsMeta = () => {
    fetchTransientErrorsMeta();
    fetchPermanentErrorsMeta();
  };

  const fetchTransientErrorsMeta = () => {
    ActivationsAPI.getActivationRunErrorMeta(activation.id, SyncFailureTypes.TRANSIENT)
      .then((res): SyncFailureMetaData => {
        return {
          recordsFailedCount: res.data.failure_count,
          warehouseErrorQuery: res.data.warehouse_query
        };
      })
      .then((metaData) => {
        setTransientErrorsMetaData(metaData);
      }, () => {
        setTransientErrorsMetaData(null);
      });
  };

  const fetchPermanentErrorsMeta = () => {
    ActivationsAPI.getActivationRunErrorMeta(activation.id, SyncFailureTypes.PERMANENT)
      .then((res): SyncFailureMetaData => {
        return {
          recordsFailedCount: res.data.failure_count,
          warehouseErrorQuery: res.data.warehouse_query,
        };
      })
      .then((metaData) => {
        setPermanentErrorsMetaData(metaData);
      }, () => {
        setPermanentErrorsMetaData(null);
      });
  };

  const getLastRetriedSyncItem = () => {
    ActivationsAPI.getActivationLastRetriedRun(activation.id)
      .then((res) => {
        if (res.count) {
          const [rawRun] = res.data;
          setLastRetriedSyncRun(SyncHistoryItemFactory(rawRun));
        }
      });
  };

  return (transientErrorsMetaData?.recordsFailedCount || permanentErrorsMetaData?.recordsFailedCount ? (
      <div>
        <div className='text-bold ml-5 mb-5'>
          Activation Run Summary
        </div>

        {transientErrorsMetaData?.recordsFailedCount ? (
          <FailedRecordsCard
            activation={activation}
            failureType={syncFailureTypes.TRANSIENT}
            failureMetaData={transientErrorsMetaData}
            lastRetriedSyncRun={lastRetriedSyncRun}
          />
        ) : null}

        {permanentErrorsMetaData?.recordsFailedCount ? (
          <FailedRecordsCard
            activation={activation}
            failureType={syncFailureTypes.PERMANENT}
            failureMetaData={permanentErrorsMetaData}
          />
        ) : null}
      </div>
    ) : null
  );
}

export default ActivationSummary;
